/* eslint-disable @typescript-eslint/no-explicit-any */
import { ANALYST_ACTION_FALLBACKS } from "@/constants/messages";
import { userFacingErrorMessage } from "@/utils/extract-rtk-error";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "components/ui/form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { FormSchema } from "./validate-form";
import { useUpdateDivergenceMutation } from "@/services/divergence";
import { toast } from "components/ui/use-toast";
import { Textarea } from "components/ui/textarea";

export function AddComment({ version, id }: any) {
  const { handleModal } = useDialogModal();

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
  });

  const [updateDivergence] = useUpdateDivergenceMutation();

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    try {
      await updateDivergence({
        divergence_comments: data.comments,
        version,
        id,
      }).unwrap();
      handleModal({
        isOpen: false,
      });
      form.reset();
      toast({
        variant: "default",
        description: "Comentário salvo com sucesso",
        duration: 5000,
      });
    } catch (error) {
      toast({
        variant: "destructive",
        description: userFacingErrorMessage(
          error,
          ANALYST_ACTION_FALLBACKS.ACTION_FAILED
        ),
        duration: 5000,
      });
    }
  }
  return (
    <div className="min-w-[300px]">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="space-y-4 w-full">
            <FormField
              control={form.control}
              name="comments"
              render={({ field }) => (
                <FormItem className="w-full">
                  <Textarea
                    {...field}
                    maxLength={1000}
                    name="comments"
                    className="min-h-[120px] min-w-[400px]"
                    placeholder="Escreva o comentário."
                  />
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="w-full flex gap-4 justify-end">
              <Button
                variant="ghost"
                type="button"
                onClick={() =>
                  handleModal({
                    isOpen: false,
                  })
                }
              >
                Voltar
              </Button>
              <Button type="submit" variant="default" isLoading={false}>
                Salvar
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </div>
  );
}
